// extracted by mini-css-extract-plugin
module.exports = {"gtwasheim":"b"};